// @flow

import React, { Component } from "react";
import classNames from "classnames";
import { localize } from "redux-i18n";
import { View, Text } from "@components";
import type { WidgetProps } from "@rjsf/utils";
type Props = $Exact<{
  ...WidgetProps,
  options: Object,
}>;

class TextareaWidget extends Component<Props> {
  handleChange = (event: SyntheticEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value;
    const { emptyValue } = this.props.options;
    this.props.onChange(value === "" ? emptyValue : value);
  };

  get value() {
    return this.props.value || "";
  }

  get remaining(): number | null {
    const maxLength = this.props.schema && this.props.schema.maxLength;
    return typeof maxLength === "number" ? Math.max(0, maxLength - this.value.length) : null;
  }

  render() {
    const props = {
      ...this.props,
      ...this.props.options,
      ...(this.props.schema && this.props.schema.hasOwnProperty("minimum")
        ? { min: this.props.schema.minimum }
        : {}),
      ...(this.props.schema && this.props.schema.hasOwnProperty("maxLength")
        ? { maxLength: this.props.schema.maxLength }
        : {}),
      onChange: this.handleChange,
      value: this.value,
    };

    if (props.readonly || (props.disabled && props.minimizeDisabled)) {
      return (
        <textarea
          disabled={props.disabled}
          readOnly={props.readonly}
          id={props.id}
          className={classNames("form-control", this.props.className)}
          rows={props.rows}
          value={props.value}
        />
      );
    }

    return (
      <View>
        <textarea
          disabled={props.disabled}
          id={props.id}
          rows={props.rows}
          maxLength={props.maxLength}
          name={props.name}
          onBlur={props.onBlur}
          onChange={props.onChange}
          onFocus={props.onFocus}
          placeholder={props.placeholder}
          readOnly={props.readonly}
          value={props.value}
          style={props.style}
          className={classNames("form-control", this.props.className)}
        />
        {this.remaining !== null && (
          <View alignSelf="flex-end">
            <Text size={0.75} color="black">
              {this.props.t("CHARACTERS_REMAINING", { count: this.remaining })}
            </Text>
          </View>
        )}
      </View>
    );
  }
}

export default localize()(TextareaWidget);
